import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

/**
 * AdminRouteGuard protects admin routes:
 * - Unauthenticated users → redirect to /auth/login
 * - Non-admin users → Access Denied UI
 * - Admin users → render child routes via <Outlet />
 */
export function AdminRouteGuard() {
  const { user, isLoading, isAuthenticated } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    )
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/auth/login" replace />
  }

  if (user.role !== 'admin') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-red-600">Access Denied</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            You do not have permission to access the admin portal.
          </p>
          <a
            href="/dashboard"
            className="text-blue-600 dark:text-blue-400 hover:underline mt-4 inline-block"
          >
            Return to Dashboard
          </a>
        </div>
      </div>
    )
  }

  return <Outlet />
}
